import sharedEnUs from "@workleap-ai/shared/localization/en-US/translation.json" with { type: "json" };
import sharedFrCa from "@workleap-ai/shared/localization/fr-CA/translation.json" with { type: "json" };
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnUs from "./en-US/translation.json" with { type: "json" };
import translationFrCa from "./fr-CA/translation.json" with { type: "json" };

const resources = {
    "en-US": {
        translation: { ...translationEnUs },
        shared: { ...sharedEnUs }
    },
    "fr-CA": {
        translation: { ...translationFrCa },
        shared: { ...sharedFrCa }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en-US",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
